import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { SunIcon, PaletteIcon, HeartPulseIcon, WrenchIcon, ShieldIcon, MaximizeIcon, LayersIcon, SparklesIcon, RefreshCwIcon } from 'lucide-react';
const concerns = [{
  name: 'Sun Damage',
  icon: SunIcon,
  description: 'Photofacials are particularly effective at reducing the signs of sun damage like sunspots, age spots, and freckles. The intense pulsed light targets the excess melanin in these areas, causing it to gradually fade.'
}, {
  name: 'Uneven Skin Tone',
  icon: PaletteIcon,
  description: "If you have an uneven skin tone with areas of hyperpigmentation, photofacials can help balance your skin's coloration, leaving it more even and radiant."
}, {
  name: 'Redness and Rosacea',
  icon: HeartPulseIcon,
  description: 'Photofacials can target redness caused by broken blood vessels or conditions like rosacea. The treatment can help reduce redness and improve overall skin tone.'
}, {
  name: 'Fine Lines & Wrinkles',
  icon: WrenchIcon,
  description: 'They can help improve the appearance of fine lines and shallow wrinkles by stimulating collagen production and enhancing skin texture.'
}, {
  name: 'Acne Scars',
  icon: ShieldIcon,
  description: 'Photofacials can reduce the redness and discoloration associated with acne scars. Over time, the appearance of scars fade to create a smoother complexion.'
}, {
  name: 'Enlarged Pores',
  icon: MaximizeIcon,
  description: 'Photofacials can help reduce the size of enlarged pores by stimulating collagen and tightening the skin. Smaller pores can result in a smoother, more refined complexion.'
}, {
  name: 'Texture Irregularities',
  icon: LayersIcon,
  description: 'If you have rough or uneven skin texture, photofacials can help improve it by encouraging the growth of healthy new skin cells.'
}, {
  name: 'Dull Complexion',
  icon: SparklesIcon,
  description: 'Photofacials can rejuvenate your skin and give it a more youthful and radiant appearance, particularly if your skin looks tired or lackluster.'
}, {
  name: 'Overall Skin Rejuvenation',
  icon: RefreshCwIcon,
  description: 'Photofacials are often used for overall skin rejuvenation, providing a fresher, more youthful look without the downtime associated with more aggressive treatments.'
}];
export function BBLConcerns() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-208">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-209">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-210">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-211">
            Be BRIGHT
          </span>

          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-212">
            WHAT KIND OF COSMETIC CONCERNS DOES BBL IMPROVE?
          </h2>

          <p className="font-serif italic text-[#333333] text-[17px] leading-[1.7] max-w-[800px] mb-6" data-id="element-213">
            BBL safely and effectively addresses a variety of common cosmetic
            concerns, giving our patients back the confidence they deserve;
            facing each day with radiant, healthy skin:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-214"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-215">
          {concerns.map((concern, index) => <AnimateOnScroll key={index} delay={index * 60} data-id="element-216">
              <div className="bg-white p-7 shadow-[0_4px_16px_rgba(0,0,0,0.06)] h-full group hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] transition-shadow duration-300" data-id="element-217">
                <concern.icon size={36} strokeWidth={1.5} className="text-[#FF1493] mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-218" />
                <h3 className="text-black text-[17px] font-bold font-[Poppins,_sans-serif] mb-2" data-id="element-219">
                  {concern.name}
                </h3>
                <p className="text-[#666666] text-sm leading-[1.6] font-body" data-id="element-220">
                  {concern.description}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}